import { COLOR_PALETTE } from 'constants/ui';

export const groupHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '4px 16px 4px 8px',
  cursor: 'pointer',
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

export const groupHeaderLeftStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

export const groupCountBadgeStyles = {
  backgroundColor: COLOR_PALETTE.GRAY[5],
  color: ({ palette }) => palette.text.strong,
  borderRadius: '10px',
  padding: '0 6px',
};

export const chevronIconStyles = {
  transition: 'transform 200ms ease',
  color: ({ palette }) => palette.text.secondary,
};

export const chevronIconExpandedStyles = {
  ...chevronIconStyles,
  transform: 'rotate(180deg)',
};
